import { isRecord } from "../document/model";
import type { EngineDocument } from "../scene/model";
import { assertEngineDocument } from "../scene/validation";

export interface StoredProjectRecord {
  format: "creator-engine-pro-document";
  version: 1;
  document: EngineDocument;
}

export function copyDocument<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}

/** JSON storage uses the same engine schema as the portable .cepro container. */
export function encodeStoredDocument(
  document: EngineDocument,
  snapshot: <T>(value: T) => T = copyDocument,
): StoredProjectRecord {
  assertEngineDocument(document);
  return {
    format: "creator-engine-pro-document",
    version: 1,
    document: snapshot(document),
  };
}

export function decodeStoredDocument(value: unknown): EngineDocument {
  if (
    !isRecord(value) ||
    value.format !== "creator-engine-pro-document" ||
    value.version !== 1
  )
    throw new Error("Неподдерживаемая версия сохранённого проекта.");
  assertEngineDocument(value.document);
  return copyDocument(value.document);
}
